








import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Utils
 */

/**
 * Components
 */

/**
 * API
 */

/**
 * Types
 */


/**
 * VueX Modules
 */

/**
 * Admin teams list page.
 */
@Component
export default class StatCard extends Vue {
	@Prop({required: true})
	title!: string;
}
